import { AccessRequest } from '@/interfaces/accessRequest.interface';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { Request } from '@/interfaces/request.interface';
import { AppNav } from '@/routes/app-nav';
import { EngagementAccessService } from '@/services/engagement-access.service';
import { TitleService } from '@/services/title.service';
import Helpers from '@/shared/helpers';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-approval-page',
  standalone: false,
  templateUrl: './approval-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./approval-page.component.scss']
})
export class ApprovalPageComponent {

  public readonly messageKey = "approval";
  public error: string = "";
  public loading: boolean = false;
  private helpers: Helpers;
  requestEntry: AccessRequest|null = null;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private engagementAccessService: EngagementAccessService,
    private route: ActivatedRoute
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.StatusMonitor.title);
    this.loadRequestEntry();
  };

  loadRequestEntry(): void {
    this.loading = true;
    this.route.params.subscribe(params => {
      this.engagementAccessService.getRequest(params['id'])
        .then(
          (response: HttpResponse<ApiResponse>) => {
            this.loading = false;
            const entry = response.body as AccessRequest|null;
            this.requestEntry = entry;
          },
          (response: HttpErrorResponse) => {
            this.loading = false;
            this.error = response.message || response.error || response;
          }
        );
    });
  }

  approve(requestId: string, accept: boolean){
    this.engagementAccessService.approveRequest(requestId, accept)
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loadRequestEntry();
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );
  }
}
